import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { HeroSection } from "../components/HeroSection";
import { FeaturedCollections } from "../components/FeaturedCollections";
import { ProductRail } from "../components/ProductRail";
import { TestimonialsSection } from "../components/TestimonialsSection";
import { InstagramStrip } from "../components/InstagramStrip";
import { NewsletterForm } from "../components/NewsletterForm";
import { LoyaltyStrip } from "../components/LoyaltyStrip";
import { ChatbotWidget } from "../components/ChatbotWidget";
import { JsonLd } from "../components/JsonLd";
import { IfEnabled } from "../components/IfEnabled";

const SITE_URL = (process.env.REACT_APP_SITE_URL || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/$/, "");

export default function Home() {
    const orgSchema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Sukaanyas",
        url: SITE_URL || undefined,
        logo: SITE_URL ? `${SITE_URL}/icon-512.png` : undefined,
        description: "A premium Indian women's wear boutique. Sarees, lehengas and ethnic ensembles, hand-curated for the modern woman.",
        sameAs: ["https://instagram.com/sukaanyas"],
    };
    return (
        <div className="min-h-screen bg-ivory" data-testid="home-page">
            <JsonLd id="ld-organization" data={orgSchema} />
            <Header />
            <main>
                <IfEnabled flag="hero">
                    <HeroSection />
                </IfEnabled>

                <IfEnabled flag="loyalty_tiers">
                    <LoyaltyStrip />
                </IfEnabled>

                <IfEnabled flag="featured_collections">
                    <FeaturedCollections />
                </IfEnabled>

                <IfEnabled flag="new_arrivals">
                    <ProductRail
                        eyebrow="Just landed"
                        title="New arrivals"
                        params={{ sort: "new", limit: 8 }}
                        viewAllHref="/category/sarees"
                        testId="new-arrivals-section"
                    />
                </IfEnabled>

                <IfEnabled flag="best_sellers">
                    <div className="bg-beige">
                        <ProductRail
                            eyebrow="Most loved"
                            title="Best sellers"
                            params={{ sort: "bestSelling", limit: 8 }}
                            viewAllHref="/category/sarees"
                            testId="best-sellers-section"
                        />
                    </div>
                </IfEnabled>

                <IfEnabled flag="testimonials">
                    <TestimonialsSection />
                </IfEnabled>

                <IfEnabled flag="instagram_strip">
                    <InstagramStrip />
                </IfEnabled>

                <IfEnabled flag="newsletter">
                    <section className="bg-skyblue/40 py-16" data-testid="newsletter-section">
                        <div className="max-w-3xl mx-auto px-6 text-center">
                            <span className="label-eyebrow">Atelier Letters</span>
                            <h3 className="mt-3 font-display text-3xl sm:text-4xl text-inkDark">Stay close to the looms</h3>
                            <p className="mt-3 text-inkMuted">Early access to new drops, hand-picked editorials, no clutter.</p>
                            <div className="mt-7 flex justify-center">
                                <NewsletterForm source="home" />
                            </div>
                        </div>
                    </section>
                </IfEnabled>
            </main>
            <Footer />
            <ChatbotWidget />
        </div>
    );
}
